<ng-container *ngIf="service.hasSelectedSeasonTickets">
  <mat-form-field appearance="outline" class="max-width" [ngClass]="{'field-error': !checkCustomerAutocomplete }">
    <mat-label>{{ 'general.api_cart_webshop_customer' | translate }}</mat-label>
    <input type="text" placeholder="{{'general.api_cart_webshop_customer' | translate}}" matInput
           [(ngModel)]="customerUsername" [ngModelOptions]="{standalone: true}" (focus)="hasResults = true"
           (keyup)="searchCustomer($event)"
           [matAutocomplete]="customer" autocomplete="off">
    <mat-autocomplete #customer="matAutocomplete" [autoActiveFirstOption]="true"
                      [displayWith]="displayFnCustomer" (optionSelected)="selectCustomer($event)">
      <ng-container *ngIf="!filtering && !hasResults">
        <mat-option [disabled]="true">
          {{'general.api_autocomplete_no_results' | translate}}
        </mat-option>
      </ng-container>
      <ng-container *ngIf="!filtering && hasResults">
        <mat-option *ngFor="let customer of customers" [value]="customer">
          <b>{{customer.userName}} {{customer.name}} </b> <i>({{customer.email}})</i>
        </mat-option>
      </ng-container>
      <mat-option *ngIf="filtering" [disabled]="true">
        <mat-spinner diameter="16"></mat-spinner>
      </mat-option>
    </mat-autocomplete>
  </mat-form-field>
  <hr class="slim">
</ng-container>

<ng-container *ngIf="!service.isSelfService">
  <app-text-input class="max-width" [type]="TextInputType.Email" [label]="'general.api_cart_client_notification_email'"
                  [(value)]="service.clientNotificationEmail" (inputKeyup)="service.updateClientNotificationEmail(service.clientNotificationEmail)"></app-text-input>
  <hr class="slim">
</ng-container>
<div class="flex flex-column bottom-spacer">
  <app-promocode *ngIf="!service.isSelfService" [service]="service"></app-promocode>
  <app-gift-code *ngIf="authService.checkPrivileges(Privileges.GIFT_TICKET_USAGE)" [disabled]="bulkMode" [service]="service"></app-gift-code>
  <app-numeric-input class="max-width" *ngIf="!service.isSelfService && authService.checkPrivileges(Privileges.DISCOUNT_APPLY)"
                     [type]="NumericInputType.Percentage" [withLinkButton]="true" (linkButtonClicked)="service.applyDiscount(discount)"
                     [label]="'general.api_cart_discount'" [(value)]="discount"
                     (inputKeyup)="utilService.isEnterKey($event) ? service.applyDiscount(discount) : null"
                     [disabled]="bulkMode"></app-numeric-input>
</div>
